<template>
  <div class="RequeteAntiBruitList">

    <!-- ERROR MODAL -->
    <b-modal ref="globalAPILoadingErrorModal" id="globalAPILoadingErrorModal"  hide-footer title="Une erreur s'est produite">
      <div class="text-center">
        <p>Une erreur s'est produite, veuillez actualiser la page et réessayer</p>
        <b-button class="mt-3" variant="outline-dark" @click="$bvModal.hide('globalAPILoadingErrorModal')">Fermer</b-button>
      </div>
    </b-modal>

    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      color="#F9BF3B">
    </loading>

    <formTitleComponent />
    <div class="container">
      <h1 class="form_div_title text-center">Paramétrage des filtres anti bruit</h1>
      <div class="form_div">
        <div class="form_content">

          <p class="text-muted">
            Cette prompt sera envoyée à l'IA en complément du titre et du contenu de la page détectée, pour chaque requête.
            Le format de réponse est imposé automatiquement : l'IA doit toujours répondre uniquement par "yes" ou "no"
            (aucune consigne de format à ajouter dans le texte ci-dessous).
            Si la prompt d'une requête est vide, aucun appel à l'IA n'est effectué et la page détectée est automatiquement retenue.
          </p>

          <div
            v-for="requete in requetes"
            v-bind:key="requete.id"
            class="requete-anti-bruit-item mt-4"
          >
            <strong>{{ requete.name }}</strong>
            <b-form-textarea
              v-model="prompts[requete.id]"
              placeholder="Laissez vide pour désactiver l'analyse IA (toutes les pages détectées seront alors automatiquement retenues)"
              class="mt-1"
              :rows="promptRows(requete.id)"
            >
            </b-form-textarea>
            <div class="text-right mt-1">
              <b-button
                size="sm"
                variant="outline-dark"
                pill
                :disabled="!isDirty(requete) || isSaving(requete.id)"
                @click="savePrompt(requete)"
              >
                <b-spinner v-if="isSaving(requete.id)" small class="mr-1" />
                Enregistrer
              </b-button>
            </div>
            <hr>
          </div>

          <p v-if="!isRequetesLoading && requetes.length === 0" class="text-muted text-center">
            Aucune requête n'est configurée pour le moment.
          </p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { APIRequete } from '@/api/APIRequete'
import formTitleComponent from '@/components/formTitleComponent'

const apiRequete = new APIRequete()

export default {
  name: 'RequeteAntiBruitList',
  components: {
    formTitleComponent,
    Loading
  },
  data: function () {
    return {
      requetes: [],
      isRequetesLoading: true,
      // Prompt currently edited in each requête's textarea, keyed by requête id
      prompts: {},
      // requête ids currently being saved, keyed by requête id
      savingRequeteIds: {},
    }
  },
  computed: {
    token () {
      return this.$store.state.auth.token
    },
    isLoading () {
      return this.isRequetesLoading
    },
  },
  created: function() {
    this.getAllRequetes()
  },
  methods: {
    // ------------- GETTERS ------------------
    getAllRequetes () {
      this.isRequetesLoading = true
      apiRequete.getAllRequetes(this.token)
      .then((result) => {
        this.requetes = result.data
        const prompts = {}
        this.requetes.forEach((requete) => {
          prompts[requete.id] = requete.prompt || ''
        })
        this.prompts = prompts
      })
      .catch((error) => {
        this.$refs.globalAPILoadingErrorModal.show()
        throw new Error('RequeteAntiBruitList getAllRequetes API Error : ' + String(error))
      })
      .finally(() => {
        this.isRequetesLoading = false
      })
    },

    isDirty (requete) {
      return (this.prompts[requete.id] || '') !== (requete.prompt || '')
    },

    isSaving (requeteId) {
      return !!this.savingRequeteIds[requeteId]
    },

    promptRows (requeteId) {
      // Grows the textarea to fit the prompt content (min 3, max 30 rows).
      const nbLines = (this.prompts[requeteId] || '').split('\n').length
      return Math.min(Math.max(nbLines + 1, 3), 30)
    },

    // ----------- SAVE PROMPT -----
    savePrompt (requete) {
      this.$set(this.savingRequeteIds, requete.id, true)
      const prompt = this.prompts[requete.id] || ''
      apiRequete.modifyRequete(
        this.token, requete.id, requete.name,
        requete.inclusion, requete.second_part_inclusion, requete.exclusion,
        prompt)
      .then(() => {
        requete.prompt = prompt
        this.$bvToast.toast(`Filtre anti bruit de la requête "${requete.name}" enregistré`, {
          title: 'Filtre anti bruit enregistré',
          variant: 'success',
          solid: true,
        })
      })
      .catch((error) => {
        this.$refs.globalAPILoadingErrorModal.show()
        throw new Error('RequeteAntiBruitList savePrompt API Error : ' + String(error))
      })
      .finally(() => {
        this.$set(this.savingRequeteIds, requete.id, false)
      })
    },
  }
}
</script>
